import {
  CHAT_UI_SUPPORTED_LOCALES,
  DEFAULT_CHAT_UI_LOCALE,
  type ChatUiSupportedLocale,
} from "@trimble-agentic-external-npm-local/agentic-chat-react"

/**
 * Maps an MXP public language code (`en`, `de`, `zh-Hant`, ...) onto the
 * closest locale Assist ships translations for.
 */
export function toAssistLocale(
  publicLang: string | undefined,
): ChatUiSupportedLocale {
  if (!publicLang) return DEFAULT_CHAT_UI_LOCALE

  const normalized = publicLang.toLowerCase()

  const exact = CHAT_UI_SUPPORTED_LOCALES.find(
    locale => locale.toLowerCase() === normalized,
  )
  if (exact) return exact

  // Chinese is the one case where the script/region, not the language,
  // decides which bundle to use.
  if (normalized.startsWith("zh")) {
    return /hant|tw|hk|mo/.test(normalized) ? "zh-TW" : "zh-CN"
  }

  const base = normalized.split("-")[0]
  const match = CHAT_UI_SUPPORTED_LOCALES.find(
    locale => locale.split("-")[0] === base,
  )
  return match ?? DEFAULT_CHAT_UI_LOCALE
}